import React, { useEffect, useState } from 'react'
import { SelectField } from '../../Base/Form'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { setSort, setFilters } from '../../../../js/lib/redux/slices/booking'
import useResponsiveView from '../../../hooks/useResponsiveView'

const ResultsHeader = ({
  totalCars,
  gridView = false,
  handleGridView,
  handleListView,
  sortOptions,
  hideViews,
  dictionary,
  fleet,
  isInpath,
  groups,
  handleChangeCountry,
  setOpenFiltersDrawer,
}) => {
  const { sort, filters } = useSelector((state) => state.booking)
  const dispatch = useDispatch()
  const countries = fleet ? window.fleetData?.records?.countries : []
  const { isDevice } = useResponsiveView()

  const { control, setValue, watch } = useForm()
  const [isGridActive, setIsGridActive] = useState(false)

  useEffect(() => {
    if (fleet) {
      setValue('country', countries?.find((item) => item.selected)?.value)
    } else {
      setValue('sort', sort || 'default')
    }
  }, [fleet])

  useEffect(() => {
    const hasTwoBrandsWithSameGroup = groups.some(
      (group) => group.cars.length === 2
    )
    setIsGridActive(hasTwoBrandsWithSameGroup)
    if (!hasTwoBrandsWithSameGroup) handleListView()
  }, [groups])

  useEffect(() => {
    if (watch('sort') !== sort) dispatch(setSort(watch('sort')))
  }, [watch('sort')])

  useEffect(() => {
    if (watch('country')) handleChangeCountry(watch('country'))
  }, [watch('country')])

  return (
    <div
      className={`b-results-header ${
        isInpath ? 'b-results-header--inpath' : ''
      }`}>
      {isDevice && isInpath && (
        <button
          type="button"
          className="btn btn-outline-primary btn-full-width"
          onClick={() => setOpenFiltersDrawer(true)}
          title={dictionary.filtersFloatingBtn}>
          <i className="icon-filter"></i>
          {dictionary.filtersFloatingBtn}
        </button>
      )}
      <h4 className="h4 m-0 b-results-header__total-cars">
        {totalCars} {dictionary.carsAvailable}
      </h4>
      {(!isDevice || fleet) && (
        <div className="b-results-header__sort-view-container">
          <div className="b-results-header__sort">
            <label htmlFor={fleet ? 'country-select' : 'sort-select'}>
              {fleet ? dictionary.filterByCountry : dictionary.sortByLabel}:
            </label>
            <SelectField
              name={fleet ? 'country' : 'sort'}
              control={control}
              label=""
              variant="outlined"
              options={fleet ? countries : sortOptions}
              style={{ height: '40px' }}
              id={fleet ? 'country-select' : 'sort-select'}
            />
          </div>
          {!hideViews && (
            <div className="b-results-header__view">
              <label htmlFor="ListViewBtn">
                {gridView ? dictionary.gridView : dictionary.listView}:
              </label>
              <button
                id="ListViewBtn"
                type="button"
                className="btn p-0"
                onClick={handleListView}
                aria-label="Switch to list view"
                aria-pressed={!gridView}>
                <i
                  className={`icon-list-view ${!gridView ? 'active' : ''}`}></i>
              </button>
              <button
                id="GridViewBtn"
                type="button"
                className="btn p-0"
                disabled={!isGridActive}
                onClick={handleGridView}
                aria-label="Switch to grid view"
                aria-pressed={gridView}>
                <i
                  className={`icon-list-view grid ${
                    gridView ? 'active' : ''
                  }`}></i>
              </button>
            </div>
          )}
          {isInpath && (
            <button
              type="button"
              className="btn b-results-header__filters-btn"
              onClick={() => setOpenFiltersDrawer(true)}
              title={dictionary.filtersFloatingBtn}>
              <i className="icon-filter"></i>
              {dictionary.filtersFloatingBtn}
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default ResultsHeader
